import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { BUSINESS } from '../constants/business';

const PrivacyPolicy: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy — {BUSINESS.displayName}</title>
        <meta name="description" content={`Privacy policy for ${BUSINESS.displayName}. Learn how we collect, use, and protect your personal information.`} />
        <link rel="canonical" href={`${BUSINESS.siteUrl}/privacy-policy`} />
      </Helmet>

      <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: '#f9fafb' }}>
        <Container maxWidth="md">
          <Typography variant="h1" sx={{ mb: 4, fontSize: { xs: '2rem', md: '2.5rem' }, fontWeight: 700, color: '#1f2937' }}>
            Privacy Policy
          </Typography>

          <Typography variant="body2" sx={{ mb: 4, color: '#6b7280' }}>
            Last updated: April 2026
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Information We Collect
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                When you use our website or contact us for title services, we may collect personal information
                including your name, email address, phone number, mailing address, and details related to your
                real estate transaction. We collect this information when you submit a contact form, request a
                quote, or communicate with us directly.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                How We Use Your Information
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                We use the information we collect to provide title insurance and closing services, respond to
                your inquiries, process your transactions, communicate with you about your services, and improve
                our website and offerings. We do not sell, trade, or rent your personal information to third parties.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Information Sharing
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                We may share your information with title insurance underwriters, lenders, real estate agents,
                attorneys, and other parties involved in your real estate transaction as necessary to provide our
                services. We may also share information when required by law or to protect our legal rights.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Data Security
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                We implement reasonable security measures to protect your personal information from unauthorized
                access, alteration, disclosure, or destruction. Our website uses SSL encryption to protect data
                transmitted between your browser and our servers.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Cookies and Analytics
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                Our website may use cookies and Google Analytics to understand how visitors interact with our site.
                This data helps us improve our website experience. You can control cookie settings through your
                browser preferences.
              </Typography>
            </section>

            <section>
              <Typography variant="h5" sx={{ mb: 2, fontWeight: 600, color: '#1e3a8a' }}>
                Contact Us
              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.7, color: '#374151' }}>
                If you have questions about this privacy policy or how we handle your information, please
                contact us at {BUSINESS.contact.email} or call {BUSINESS.contact.phoneDisplay}.
              </Typography>
            </section>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default PrivacyPolicy;
